<template>
  <div class="container">
  <div class="row mt-5">
    <div class="mb-3">
      <h2>คำนวณราคาเฉลี่ยหุ้น</h2>
    
    <h3>หุ้นที่มีอยู่</h3>
    <label for="exampleFormControlInput1" class="form-label">จำนวนหน่วยเดิม:</label>
    <input type="number" class="form-control" v-model.number="oldUnits" placeholder="หน่วยเดิม">
    
    <label for="exampleFormControlInput1" class="form-label">ราคาเฉลี่ยเดิม:</label>
    <input type="number" class="form-control" v-model.number="oldAvgPrice" placeholder="ราคาเฉลี่ยเดิม">

    <h3>หุ้นที่กำลังจะซื้อ</h3>
    <label class="form-label">ราคาต่อหน่วย:</label>
    <input type="number" class="form-control" v-model.number="newPrice" placeholder="ราคาที่จะซื้อ">
    
    <label class="form-label">จำนวนเงินที่ใช้ซื้อ:</label>
    <input type="number" class="form-control" v-model.number="newAmount" placeholder="จำนวนเงินที่จะใช้ซื้อ">
    
    <button @click="calculate" type="submit" class="btn btn-success mt-3 mb-3">คำนวณ</button>

    <h3>ผลลัพธ์</h3>
    <p>จำนวนหน่วยใหม่: {{ newUnits }} หน่วย</p>
    <p>จำนวนหน่วยรวม: {{ totalUnits }} หน่วย</p>
    <p>ราคาเฉลี่ยใหม่: {{ newAvgPrice.toFixed(2) }} บาท</p>
</div>
</div>
  </div>
</template>

<script>

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  components:{
  },
  data() {
    return {
      oldUnits: 0,  // จำนวนหน่วยเดิม
            oldAvgPrice: 0,  // ราคาเฉลี่ยเดิม
            newPrice: 0,  // ราคาหุ้นใหม่
            newAmount: 0,  // จำนวนเงินที่ซื้อ
            newUnits: 0,  // จำนวนหน่วยที่ได้จากการซื้อใหม่
            totalUnits: 0,  // จำนวนหน่วยรวม
            newAvgPrice: 0  // ราคาเฉลี่ยใหม่
    };
  },
  mounted() {
  
  },
  methods: {
    calculate() {
            if (this.newPrice > 0 && this.newAmount > 0) {
                this.newUnits = this.newAmount / this.newPrice;  // คำนวณจำนวนหน่วยใหม่
                this.totalUnits = this.oldUnits + this.newUnits;  // รวมจำนวนหน่วยทั้งหมด

                if (this.totalUnits > 0) {
                    let totalCost = (this.oldUnits * this.oldAvgPrice) + this.newAmount;  // รวมเงินทั้งหมด
                    console.log('totalCost',totalCost);
                    console.log('totalUnits',this.totalUnits);
                    this.newAvgPrice = totalCost / this.totalUnits;  // คำนวณราคาเฉลี่ยใหม่
                }
            }
        }
  },
  computed: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
